<template>
  <wa-modal-frame
    :is-showing="isShowing"
    :has-sections="false"
    :title="`You need a ${upsellRequirement} for that!`"
    component-class="upsell"
    has-actions
    @close-modal="$emit('close-modal')"
  >
    <slot name="upsell-description">
      <p class="line-length-xl margin-bottom-xl">
        <span class="size-lg">
          <font-awesome-icon
            v-if="upsellTriggerIconName"
            :icon="$v6[upsellTriggerIconStyle][upsellTriggerIconName]"
            class="margin-right-5xs"
          />
          <strong>{{ upsellTrigger }}</strong> requires a {{ upsellRequirement }}.
        </span>

        <span
          class="size-lg"
          >Here are some of our popular plans that will get you access, or you can
          <site-link
            :to="{ name: 'plans' }"
            class="no-underline"
            @click.native="$posthog.capture('view_plans_button_click', { context: 'upsell_modal', feature: upsellTriggerSlug })"
            >view all our plans</site-link
          >.</span
        >
      </p>
    </slot>

    <slot name="upsell-options">
      <upsell-options
        :icon="icon"
        :is-custom-icon="isCustomIcon"
        :upsell-trigger-slug="upsellTriggerSlug"
        :upsell-trigger="upsellTrigger"
      />
    </slot>

    <template slot="actions">
      <div class="row size-sm muted align-center tablet:align-start tablet:text-left">
        <div class="column-12 tablet:column-6">
          <p v-if="!isSignedIn">
            Already have a Pro plan?
            <site-link
              :to="{ name: 'sessions.sign-in', query: { next: signInNext } }"
              class="no-underline"
              @click.native="$posthog.capture('sign_in_button_click', { context: 'upsell_modal', feature: upsellTriggerSlug })"
            >
              Sign in
            </site-link>
          </p>
        </div>
        <div :class="['column-12 tablet:column-6 tablet:text-right', { 'margin-top-md tablet:margin-top-0': !isSignedIn }]">
          <p>
            <site-link
              :to="{ name: 'plans' }"
              class="no-underline"
              @click.native="$posthog.capture('view_plans_button_click', { context: 'upsell_modal', feature: upsellTriggerSlug })"
              >View all plans and details</site-link
            >
          </p>
        </div>
      </div>
    </template>
  </wa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'
  import { EventTrackingMixin, ABTestMixin } from 'app/mixins'
  import { snakeCase } from 'lodash'
  import path from 'path'

  import UpsellOptions from './UpsellOptions'

  export default {
    name: 'ModalUpsell',

    components: {
      UpsellOptions
    },

    mixins: [ModalFrameMixin, EventTrackingMixin, ABTestMixin],

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      icon: {
        type: Object
      },
      isCustomIcon: {
        type: Boolean,
        default: false
      },
      upsellRequirement: {
        type: String,
        required: true
      },
      upsellTrigger: {
        type: String,
        required: true
      },
      upsellTriggerIconName: {
        type: String,
        required: true
      },
      upsellTriggerIconStyle: {
        type: String,
        default: 'solid'
      }
    },

    computed: {
      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      signInNext() {
        return path.join(this.$router.history.base, this.$route.fullPath)
      },

      upsellTriggerSlug() {
        return snakeCase(this.upsellTrigger)
      }
    }
  }
</script>
